/**
 * Simple HTML sanitizer to prevent XSS attacks
 * Removes potentially dangerous HTML tags and attributes
 */
export const sanitizeHtml = (html: string): string => {
    // Remove script tags and their content
    html = html.replace(/<script\b[^<]*(?:(?!<\/script>)<[^<]*)*<\/script>/gi, '');

    // Remove dangerous attributes
    html = html.replace(/\s*on\w+\s*=\s*"[^"]*"/gi, ''); // onclick, onload, etc.
    html = html.replace(/\s*on\w+\s*=\s*'[^']*'/gi, '');
    html = html.replace(/javascript:/gi, '');
    html = html.replace(/vbscript:/gi, '');
    html = html.replace(/data:/gi, '');

    // Remove dangerous tags but keep their content
    html = html.replace(/<\/?(?:iframe|object|embed|link|meta|form|input|textarea|select|option|button)\b[^>]*>/gi, '');

    return html;
};

/**
 * Safe HTML renderer that sanitizes content before rendering
 */
export const createSafeHtml = (html: string) => ({
    __html: sanitizeHtml(html),
});
